import React from 'react';
import { Instagram, Twitter, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#060B28] border-t border-[#151934] text-gray-400 py-8">
      <div className="max-w-7xl mx-auto px-4">
        <nav className="flex justify-center space-x-8 mb-6">
          <a href="/" className="hover:text-white transition-colors">Ana Sayfa</a>
          <a href="/membership" className="hover:text-white transition-colors">Abonelik Paketleri</a>
     
          <a href="/support" className="hover:text-white transition-colors">Destek Merkezi</a>
          <a href="/contact" className="hover:text-white transition-colors">İletişim</a>
        </nav>
        
        <div className="flex justify-center space-x-4 mb-6">
          <a 
            href="https://instagram.com" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="hover:text-white transition-colors"
          >
            <Instagram size={24} />
          </a>
          <a 
            href="https://twitter.com" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="hover:text-white transition-colors"
          >
            <Twitter size={24} />
          </a>

          <a 
            href="https://www.youtube.com" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="hover:text-white transition-colors"
          >
            <Youtube size={24} />
          </a>
        </div>
        
        <div className="text-center">
          <p>© 2025 Smart Portföy</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;